const AUTH_TOKEN_KEY = "cliqsuite_auth_token";

/**
 * Shared across every app via `localStorage` (each app is on its own
 * origin/subdomain, so there's no cross-app collision despite the shared
 * key name). Owner Portal and Admin Portal call `setAuthToken` after
 * login/signup/logout; apps that never authenticate (Guest Portal,
 * PIN-gated POS/Kitchen/Service) simply never call it, so `getAuthToken`
 * stays null and mutations to their tables — which aren't auth-gated on
 * sync-api — go out with no Authorization header, same as before.
 */
export function getAuthToken(): string | null {
  try {
    return localStorage.getItem(AUTH_TOKEN_KEY);
  } catch {
    return null;
  }
}

export function setAuthToken(token: string | null): void {
  try {
    if (token) localStorage.setItem(AUTH_TOKEN_KEY, token);
    else localStorage.removeItem(AUTH_TOKEN_KEY);
  } catch {
    // localStorage unavailable (e.g. private browsing) — nothing to do.
  }
}
